module.exports = __webpack_public_path__ + "dd673dac0c63b490da268a949a5ed25d.png";